import './style.scss'

const prefixCls = 'sl-tabs';

const computeLeft = (el , l) => {
  let left = 0
  for(let i = 0;i<l;i++){
    left += el[i].offsetWidth + 32
  }
  return left
}

export const Tabs = {
  name:'Tabs',
  props:['value'],
  data(){
    return {
      tabsData:null,
      currentTab:null,
      inkStyle:{

      }
    }
  },
  computed:{

  },
  created(){
    this.$watch('value' , function(nv){
      this.currentTab = nv
    },{immediate:true})

    this.$watch('currentTab' , function(nv){
      this.computedStyle()
    })
  },
  methods:{
    computedStyle(){
      const bar = this.$refs['bars']
      const { tabsData } = this
      // console.log(this, tabsData)
      if( tabsData && bar && this.currentTab ){
        const barChildren = bar.childNodes
        // console.log(barChildren.values())
        let idx = this.tabsData.findIndex(i => i.name == this.currentTab)
        if( idx >= 0 && barChildren[idx] ){
          let margin = 16
          let left = computeLeft(barChildren , idx)
          return {
            transform:`translate3d(${left}px, 0px, 0px)`,
            width:barChildren[idx].offsetWidth+'px'
          }
        }
      }
    },
    handleChangeTab(tab){
      this.currentTab = tab.name
      // this.$forceUpdate()
      // this.computedStyle()
    },
    renderBar(tabs){
      const { componentOptions , currentTab} = this
      const data = tabs.map( i => i.componentOptions.propsData )
      const nodes = data.map(i => (
        <div on-click={() => this.handleChangeTab(i)} class={[`${prefixCls}-tab`,i.name == currentTab ? `${prefixCls}-tab-active` : null]}>{i.label}</div>
      ))

      const inkStyle = this.computedStyle()
      return (
        <div ref="bars" class={[`${prefixCls}-bar`]}>
          {nodes}
          <div class={[`${prefixCls}-ink`]} style={inkStyle}></div>
        </div>
      )
    },
    renderContent(tabs){
      let { currentTab } = this
      
      const idx = tabs.findIndex( i => i.componentOptions.propsData.name == currentTab )
      const contentStyle = {
        'marginLeft': `-${idx}00%`
      }
      return (
        <div class={[`${prefixCls}-content`]} style={contentStyle}>
          {
            tabs.map((i , j) => (
              <div class={[`${prefixCls}-tabpane`]}>
                {j == idx ? i : null}
              </div>
            ))
          }
        </div>
      )
    }
  },
  render(){
    const { $scopedSlots } = this
    const defaultNode = $scopedSlots.default()
    if(!this.tabsData){
      this.tabsData = defaultNode.map( i => i.componentOptions.propsData )
    }

    if(!this.currentTab){
      this.currentTab = defaultNode[0].componentOptions.propsData.name
    }

    return (
      <div class={[`${prefixCls}`]}>
        {this.renderBar(defaultNode)}
        {this.renderContent(defaultNode)}
      </div>
    )
  }
}

export const TabPane = {
  name:'TabPane',
  props:['label','name'],
  render(){
    return this.$scopedSlots.default()
  }
}

